import React from 'react';
import { ModuleSuggestionsVO } from '../services/aiAssistant';

interface Props {
  suggestions: ModuleSuggestionsVO | null;
  onPick: (text: string) => void;
}

export default function EmptyState({ suggestions, onPick }: Props) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 24 }}>
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #2A6FF5, #5B8DEF)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 18,
          boxShadow: '0 6px 16px rgba(42,111,245,0.25)'
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" width={34} height={34}>
          <path d="M14 2L5 13.5h6.5L10 22l9.5-11H13L14 2Z" fill="#fff" />
          <path d="M13.5 2.5L11 10.5h3L12.2 17l5.8-7h-4l2.5-7.5-3-.5z" fill="#fff" opacity={0.22} />
        </svg>
      </div>
      <div style={{ fontSize: 16, fontWeight: 700, color: '#1F2937', marginBottom: 6 }}>
        你好 <span style={{ fontSize: 18 }}>👋</span> 我能<span style={{ color: '#2A6FF5' }}>基于本页面</span>帮你
      </div>
      {suggestions?.capabilities?.length ? (
        <div style={{ fontSize: 13, color: '#9CA3AF', marginBottom: 28 }}>{suggestions.capabilities.join(' / ')}</div>
      ) : (
        <div style={{ height: 28 }} />
      )}
      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 10 }}>
        {suggestions?.suggestions?.map((s, i) => (
          <button
            type="button"
            key={i}
            onClick={() => onPick(s.text)}
            style={{
              padding: '14px 16px',
              borderRadius: 12,
              border: 'none',
              background: '#F5F7FA',
              cursor: 'pointer',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              fontSize: 14,
              color: '#262626',
              transition: 'background 0.15s, transform 0.15s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#EAF2FE';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#F5F7FA';
            }}
          >
            <span style={{ fontSize: 18 }}>{s.icon}</span>
            <span style={{ flex: 1 }}>{s.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
